import Form from 'react-bootstrap/Form';

export const AdditionalReferences = ({ formik, isReturnShipmentTab }) => {
    const values = isReturnShipmentTab ? formik.values.returnData : formik.values;
    const isMps = values.mpsPackages.length > 0;

    return (
        <>
            <Form.Group className='form-group'>
                <Form.Label>Invoice number</Form.Label>
                <Form.Control
                    name={isReturnShipmentTab ? 'returnData.invoiceNum' : 'invoiceNum'}
                    disabled={isMps}
                    {...formik.getFieldProps(isReturnShipmentTab ? 'returnData.invoiceNum' : 'invoiceNum')}
                />
            </Form.Group>
            <Form.Group className='form-group'>
                <Form.Label>Delivery instructions</Form.Label>
                <Form.Control
                    name={isReturnShipmentTab ? 'returnData.deliveryInstructions' : 'deliveryInstructions'}
                    as='textarea'
                    rows={2}
                    disabled={isMps}
                    {...formik.getFieldProps(isReturnShipmentTab ? 'returnData.deliveryInstructions' : 'deliveryInstructions')}
                />
            </Form.Group>
        </>
    )
}